import Home from './Home';
import Introducao from './Introducao';
import Identidade from './Identidade';
import ExpressaoVerbal from './ExpressaoVerbal';
import ExpressaoVisual from './ExpressaoVisual';
import Downloads from './Downloads';
import Login from './Login';
import EsqueceuSenha from './EsqueceuSenha';
import NovaSenha from './NovaSenha';

export { Home, Introducao, Identidade, ExpressaoVerbal, ExpressaoVisual, Downloads, Login, EsqueceuSenha, NovaSenha };



// WEBPACK FOOTER //
// ./src/pages/index.js